import { actions as probateCaseActions } from "./actions/legacy/probateCase";
import { TActionsDefinitionsList } from "./actions/TAction";

export const probateActions: TActionsDefinitionsList = [
    ...probateCaseActions,
];
